import { pluralize } from "@common/helpers/string";
import type { Citation } from "@common/schemas/domains/agentChat/agent-chat.schema";
import styles from "./AgentChat.module.scss";

function getSafeCitationUrl(url: string): string | null {
    try {
        const parsed = new URL(url);
        if (parsed.protocol === "http:" || parsed.protocol === "https:") {
            return parsed.href;
        }
    } catch {
        return null;
    }

    return null;
}

export const AgentChatSources: React.FC<{ citations: Citation[] }> = ({
    citations,
}) => (
    <div className={styles.sources}>
        <span className={styles.sourcesLabel}>
            {citations.length} {pluralize("source", citations.length)}:
        </span>
        <ul>
            {citations.map((citation, index) => {
                const safeUrl = getSafeCitationUrl(citation.url);

                return (
                    <li key={index}>
                        {safeUrl ? (
                            <a
                                href={safeUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {citation.title}
                            </a>
                        ) : (
                            citation.title
                        )}
                    </li>
                );
            })}
        </ul>
    </div>
);
